import type { VoidFunctionComponent } from 'react';

import { icons } from '../../../generic/Icon';
import InfoPanel from '../../../generic/InfoPanel';
import Link from '../../../generic/Link/Link';

import styles from './FossabotBlockedBox.module.less';

const SUPPORTED_ECOSYSTEMS_URL = 'https://docs.fossa.com/docs/fossabot/supported-ecosystems';

/** Why fossabot cannot open a PR for this dependency at all. */
export type FossabotBlockedNotice = {
  heading: string;
  description: string;
  /** Adds the link to the supported ecosystems docs under the description. */
  hasEcosystemsLink?: boolean;
};

type Props = {
  notice: FossabotBlockedNotice;
};

/**
 * Shown in the Remediation panel in place of the fossabot fix cards when
 * fossabot cannot open a PR for this dependency, whatever the connection state.
 */
export const FossabotBlockedBox: VoidFunctionComponent<Props> = ({ notice }) => (
  <div className={styles.box} data-testid="fossabot-blocked-box">
    <InfoPanel type="warning" icon={icons.triangleExclamationRegular}>
      <strong className={styles.heading}>{notice.heading}</strong>
      <p className={styles.description}>{notice.description}</p>
      {notice.hasEcosystemsLink && (
        <Link to={SUPPORTED_ECOSYSTEMS_URL} openInNewTab>
          <span className={styles.link}>Learn about our supported ecosystems.</span>
        </Link>
      )}
    </InfoPanel>
  </div>
);
